const SkeletonProfile = () => {
  return (
    <div className="animate-pulse">
      <div className="flex justify-center w-full lg:w-[600px] mx-auto mt-2">
        <div className="relative size-32 bg-gray-300 rounded-full"></div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-5 mt-6 w-full lg:w-[600px] mx-auto">
        {[...Array(4)].map((_, index) => (
          <div key={index} className="h-10 bg-gray-200 rounded"></div>
        ))}
        <div className="h-10 bg-gray-200 rounded"></div>
        <div className="h-10 bg-gray-200 rounded"></div>
      </div>

      <div className="mt-5 w-full lg:w-[600px] mx-auto flex flex-col gap-5">
        <div className="h-32 w-full bg-gray-200 rounded"></div>
        <div className="h-32 w-full bg-gray-200 rounded"></div>
        <div className="w-20 min-h-10 bg-gray-200 rounded-lg ml-auto"></div>
      </div>
    </div>
  );
};

export default SkeletonProfile;
